import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]
  // the dataset target element must be inside a container 
  // so that the whole thing including label, etc., can be hidden
  // when there are no results
  newItem(event) {
    event.preventDefault();

    var rowArray = this.rowTargets;
    console.log(rowArray);
    console.log(rowArray.length);

    for (let i = 0; i < rowArray.length; i++) {
      var row = rowArray[i];
      var rowFields = row.querySelectorAll('input, select');

      for (let n = 0; n < rowFields.length; n++) {
        var title = rowFields[n].getAttribute('title');
        if (title != null) {
          rowFields[n].setAttribute('aria-label', title + ' row ' + (i + 1));
        }
      }
    }
  }
}
